import axios from 'axios'
import Cookies from 'universal-cookie'
import ConfigResolver from './ConfigResolver'
import { isWpSessionExpired, refreshWpSession } from './wpSession'
import { isDevelopment } from '../utils'
// import { sendDiscordError } from '../utils'


const config = ConfigResolver.config()
const cookies = new Cookies()

const requestHandler = (request) => {
  // Django API uses legacy JWT tokens from sessionStorage
  request.headers['Authorization'] = `JWT ${sessionStorage.getItem('token')}`
  return request
}

const errorHandler = (error) => {
  console.log(error)
  // sendDiscordError('Submissions Server', error.message, error.url)
  return Promise.reject({ ...error })
}

const successHandler = (response) => {
  return response
}

const axiosInstance = axios.create({
  baseURL: `${config.apiEndpoint}/${config.apiVersion}`
})

axiosInstance.interceptors.request.use(
  request => {
    return requestHandler(request)
  }
)

axiosInstance.interceptors.response.use(
  response => {
    return successHandler(response)
  }, 
  error => {
    return errorHandler(error)
  }
)

// WordPress API instance — includes Auth0 token for authenticated WP API calls
const wpAxios = axios.create()

wpAxios.interceptors.request.use(
  request => {
    const cookieToken = cookies.get('smp_access_token')
    if (cookieToken) {
      request.headers['Authorization'] = `Bearer ${cookieToken}`
    } else {
      const sessionToken = sessionStorage.getItem('token')
      if (sessionToken) {
        request.headers['Authorization'] = `Bearer ${sessionToken}`
      }
    }
    return request
  }
)

wpAxios.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

// wp-admin/admin-ajax.php instance. These calls carry no Authorization header:
// they authenticate purely on the WordPress cookie, which the theme deletes
// the moment smp_access_token lapses (STY-634). A 400 with body '0' from here
// means "WordPress logged you out", not "bad request" — so send the browser
// through the token refresh route instead of letting every caller treat it as
// a retryable failure. The rejection is tagged so callers can stop retrying.
const wpAdminAjax = axios.create()

wpAdminAjax.interceptors.response.use(
  response => successHandler(response),
  error => {
    if (isWpSessionExpired(error)) {
      const redirecting = isDevelopment() ? false : refreshWpSession()
      return Promise.reject(Object.assign(error, { wpSessionExpired: true, redirecting: redirecting }))
    }
    return errorHandler(error)
  }
)

export { wpAxios, wpAdminAjax }
export default axiosInstance

